import type { ChipProps } from '@mui/material';
import type { SkillCategory } from '@/types/domain';

/**
 * 技能分类的显示标签
 */
export const CATEGORY_LABELS: Record<SkillCategory, string> = {
  'file-processing': 'File Processing',
  'data-extraction': 'Data Extraction',
  utilities: 'Utilities',
  custom: 'Custom',
};

/**
 * 技能分类的颜色映射
 */
export const CATEGORY_COLORS: Record<SkillCategory, ChipProps['color']> = {
  'file-processing': 'primary',
  'data-extraction': 'success',
  utilities: 'default',
  custom: 'error',
};

/**
 * 分类选项列表，用于表单下拉框
 */
export const CATEGORIES: { value: SkillCategory; label: string }[] = [
  { value: 'file-processing', label: 'File Processing' },
  { value: 'data-extraction', label: 'Data Extraction' },
  { value: 'utilities', label: 'Utilities' },
  { value: 'custom', label: 'Custom' },
];

/**
 * 建议的能力列表，用于快速选择
 */
export const SUGGESTED_CAPABILITIES = [
  'file:read',
  'file:write',
  'agent:execute',
  'db:query',
  'llm:chat',
  'export:create',
  'backup:read',
];
